<div class="notification-box" (click)="openBookMark()">
	<app-feather-icons [icon]="'sliders'"></app-feather-icons>
</div>
<div class="onhover-show-div bookmark-flip" [class.active]="bookmark">
	<div class="flip-card">
		<div class="flip-card-inner" [class.flipped]="bookmarkFlip">
			<div class="front">
				<h6 class="mb-0 dropdown-title">{{ 'Administration' | translate }}</h6>
				<ul class="bookmark-dropdown">
					<li>
						<div class="row bookmark-scroll">
							<div class="col-4 text-center" *ngFor="let item of adminRoutes">
								<div class="bookmark-content">
									<a [routerLink]="item?.path" routerLinkActive="item?.active">
										<div class="bookmark-icon">
											<app-svg-icon
												[icon]="item?.svgIcon"
												[imageIcon]="item?.svgImage"
												[useMine]="true"
											></app-svg-icon>
										</div>
										<span>{{ item.title }}</span>
									</a>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
